import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import EmailGroupCheckbox from 'account/components/email_group_checkbox';
import { unwatchAllCategories } from 'common/ducks/user';
import { unwatchAllCategories as adminUnwatchAllCats } from 'admin/ducks/people';
import { toggleEmailGroup, updateSettings } from 'account/ducks/notification_settings';

export function mapStateToProps({ notificationSettings }, { id }) {
  const { email_group } = notificationSettings.data;
  const keys = Object.keys(email_group);
  return {
    checked: keys.length > 0 && keys[0] === id,
  };
}

export function mapDispatchToProps(dispatch, { id, atAdmin }) {
  return bindActionCreators({
    onChange: partial(toggleEmailGroup, id),
    updateSettings,
    unwatchAllCategories: atAdmin? adminUnwatchAllCats : unwatchAllCategories
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailGroupCheckbox);



// WEBPACK FOOTER //
// ./account/containers/email_group_checkbox.js